import { Instagram, MapPin, Clock, ArrowUpRight } from "lucide-react";
import { Reveal } from "./Reveal";
import { useLang, ADDRESS, MAPS, INSTAGRAM, IMG } from "../lib/i18n";

export const Contact = () => {
  const { t } = useLang();
  const c = t.contact;
  return (
    <section id="contact" data-testid="contact-section" className="bg-[#F6F2EC] py-24 sm:py-36">
      <div className="max-w-[1440px] mx-auto px-5 sm:px-10">
        <Reveal><p className="overline text-[#8A6A3A] mb-6">{c.over}</p></Reveal>
        <Reveal delay={0.05}><h2 className="font-serif-d font-light text-[2.6rem] sm:text-7xl leading-[0.95] text-[#14110F]">{c.title}</h2></Reveal>
        <div className="mt-16 grid lg:grid-cols-12 gap-4">
          <Reveal className="lg:col-span-7 lg:h-full">
            <div className="relative h-[360px] sm:h-[480px] lg:h-full lg:min-h-[480px] overflow-hidden bg-[#ECE5DA]" data-testid="contact-map">
              <iframe
                title="Mappa Gioia Centro Estetico"
                src="https://maps.google.com/maps?q=Via%20Tre%20Fontane%2037%2C%2088100%20Catanzaro&z=15&output=embed"
                className="absolute inset-0 w-full h-full grayscale-[0.85] sepia-[0.15] contrast-[1.05]"
                loading="lazy"
              />
            </div>
          </Reveal>
          <div className="lg:col-span-5 grid gap-4">
            <Reveal delay={0.1}>
              <div className="bg-[#ECE5DA] p-8 sm:p-10 h-full">
                <div className="flex gap-4"><MapPin className="w-5 h-5 text-[#8A6A3A] mt-1" strokeWidth={1.3} />
                  <div><p className="overline text-[#5a534c] text-[0.62rem]">{c.address}</p><p className="font-serif-d text-2xl sm:text-3xl mt-2" data-testid="contact-address">{ADDRESS}</p></div>
                </div>
                <div className="flex gap-4 mt-8"><Clock className="w-5 h-5 text-[#8A6A3A] mt-1" strokeWidth={1.3} />
                  <div><p className="overline text-[#5a534c] text-[0.62rem]">{c.hours}</p><p className="font-serif-d text-2xl mt-2" data-testid="contact-hours">{c.hoursVal}</p></div>
                </div>
                <a data-testid="contact-directions-link" href={MAPS} target="_blank" rel="noreferrer" className="mt-10 inline-flex items-center gap-3 rounded-full bg-[#14110F] text-[#F6F2EC] px-7 py-3.5 text-[0.72rem] tracking-[0.2em] uppercase transition-colors duration-500 hover:bg-[#8A6A3A]">
                  {c.directions} <ArrowUpRight className="w-4 h-4" />
                </a>
              </div>
            </Reveal>
            <Reveal delay={0.2}>
              <a data-testid="contact-instagram-link" href={INSTAGRAM} target="_blank" rel="noreferrer" className="group relative block overflow-hidden h-[220px] bg-[#14110F]">
                <img src={IMG.realBack} alt="Massaggio da Gioia Centro Estetico" className="absolute inset-0 w-full h-full object-cover object-[50%_55%] opacity-60 transition-transform duration-[1400ms] group-hover:scale-110" />
                <div className="relative h-full p-8 flex flex-col justify-between text-[#F6F2EC]">
                  <Instagram className="w-7 h-7" strokeWidth={1.2} />
                  <div className="flex items-end justify-between">
                    <div><p className="overline text-[#e6d3ae]">{c.follow}</p><p className="font-serif-d text-3xl mt-1">{c.ig}</p></div>
                    <ArrowUpRight className="w-6 h-6 transition-transform duration-500 group-hover:rotate-45" />
                  </div>
                </div>
              </a>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
};
